import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { HashLoader } from "react-spinners";
import CreatePost from "../../components/createPost";
import Header from "../../components/header";
import LeftHome from "../../components/home/left";
import RightHome from "../../components/home/right";
import SendVerification from "../../components/home/sendVerification";
import Stories from "../../components/home/stories";
import Post from "../../components/post";
import EditorialNavigationTabs from "../../components/home/EditorialNavigationTabs";
import "./style.css";
export default function Home({ setVisible, posts, loading, getAllPosts, dispatch }) {
  const { user } = useSelector((state) => ({ ...state }));
  const middle = useRef(null);
  const [height, setHeight] = useState();
  useEffect(() => {
    setHeight(middle.current.clientHeight);
  }, [loading, height]);

  // Callback para adicionar novo post compartilhado ao feed
  const handleShare = useCallback(
    (newSharedPost) => {
      if (dispatch) {
        dispatch({
          type: "POSTS_SUCCESS",
          payload: [newSharedPost, ...posts],
        });
      }
    },
    [dispatch, posts]
  );

  return (
    <div className="home" style={{ height: `${height + 150}px` }}>
      <Header page="home" getAllPosts={getAllPosts} />
      <LeftHome user={user} />
      <div className="home_middle" ref={middle}>
        <Stories />
        {user.verified === false && <SendVerification user={user} />}
        <CreatePost user={user} setVisible={setVisible} />
        {/* Abas de Navegação Editorial */}
        <EditorialNavigationTabs />
        {loading ? (
          <div className="sekelton_loader">
            <HashLoader color="#1876f2" />
          </div>
        ) : (
          <div className="posts">
            {posts.map((post, i) => (
              <Post key={post._id || i} post={post} user={user} onShare={handleShare} />
            ))}
          </div>
        )}
      </div>
      <RightHome user={user} />
    </div>
  );
}
